var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-card"},[_c('div',{staticClass:"box-card-header"},[_vm._t("header")],2),_c('div',{staticClass:"box-card-body"},[(_vm.$store.state.isLogin)?_vm._t("body"):(!_vm.$store.state.isLogin)?_c('connect-button'):_vm._e()],2),_c('div',{staticClass:"box-card-footer"},[_vm._t("footer")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }